import { render } from "./CharacterCount.vue?vue&type=template&id=4e28d1af"
import script from "./CharacterCount.vue?vue&type=script&lang=js"
export * from "./CharacterCount.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__